export function countVisibleChips(
  widths: number[],
  available: number,
  moreWidth: number,
  gap: number,
): number {
  const n = widths.length
  if (n === 0) return 0

  const totalAll = widths.reduce((sum, w) => sum + w, 0) + (n - 1) * gap
  if (totalAll <= available) {
    return n
  }

  for (let k = n - 1; k >= 1; k--) {
    let sumK = 0
    for (let i = 0; i < k; i++) {
      sumK += widths[i]
    }
    const needed = sumK + k * gap + moreWidth
    if (needed <= available) {
      return k
    }
  }

  return 0
}
